export default __webpack_public_path__ + "static/media/linkedIn.c7a91bb1.svg";